export default __webpack_public_path__ + "static/media/select-language.f4357fb9.jpg";